import { FC } from "react";
import { formatPPSM } from "react-migration/domains/comparables/util";

import { useTranslation } from "react-migration/lib/i18n/useTranslation";
import { MeasurementSystem } from "src/js/stores/user/store";

import { PPADot } from "../../../PPADot";

export interface ItemProps {
  loading: boolean;
  price?: number;
  index: number;
  unitType: MeasurementSystem;
}

export const Item: FC<ItemProps> = ({ loading, price, index, unitType }) => {
  const { t } = useTranslation();
  const text = [
    t("comparables.map.legend.no_data"),
    t("comparables.map.legend.bottom_5"),
    t("comparables.map.legend.next_20"),
    t("comparables.map.legend.middle_50"),
    t("comparables.map.legend.next_20"),
    t("comparables.map.legend.top_5"),
  ];

  return (
    <div className="atlas-flex atlas-items-center atlas-m-2" data-testid="price-per-area-item">
      <PPADot price={0} area={0} distribution={[0]} index={index} />
      <div className="atlas-w-8">
        {index === 0 && (
          <span>
            {t("units.currency.default_currency")}/
            {unitType === MeasurementSystem.METRIC
              ? t("units.distance.short.metric")
              : t("units.distance.short.imperial")}
            <sup>2</sup>
          </span>
        )}
        {loading && index !== 0 && (
          <span className="atlas-text-background-inverse-light">
            ({t("comparables.map.legend.loading")}...)
          </span>
        )}
        {!loading && index !== 0 && (
          <span>
            {t("units.currency.default_currency")}
            {price && formatPPSM(price, unitType)}
          </span>
        )}
      </div>
      <span className="atlas-ml-3 atlas-inline-block">{!loading && text[index]}</span>
    </div>
  );
};
